module.exports = __webpack_public_path__ + "img/Je-soutiens-mon-commerce-ok.8557015d.jpg";